import { Link, useRouteError } from 'react-router-dom'

/**
 * Route-level error boundary for the protected shell. Replaces React Router's
 * raw default error screen (which dumped a minified stack at the user) with a
 * branded, recoverable fallback. Wired as `errorElement` on the protected
 * route in router.tsx, so a render/throw in ANY child page degrades here
 * instead of crashing the whole view.
 *
 * Logs to the console for now; the Sentry SDK (SENTRY_DSN already provisioned)
 * gets wired in the OpenAPI phase and will capture from here.
 */
export function RouteError() {
  const error = useRouteError() as (Error & { status?: number }) | undefined
  if (error) {
    // eslint-disable-next-line no-console
    console.error('[RouteError]', error)
  }
  return (
    <div className="briefer-list-empty" style={{ padding: '2.5rem 1.5rem', textAlign: 'center' }}>
      <h2 style={{ marginBottom: '0.5rem' }}>Algo falló al cargar esta vista</h2>
      <p style={{ opacity: 0.7, marginBottom: '1.25rem' }}>
        {error?.message ?? 'Ocurrió un error inesperado.'}
      </p>
      <Link to="/briefs" className="dock-btn">
        ← Volver a briefs
      </Link>
    </div>
  )
}
